import React, { useState } from "react";

const citySuggestions = [
  {
    id: 2,
    name: "Goa",
  },
  {
    id: 29,
    name: "Kodaikanal",
  },
  {
    id: 21,
    name: "Dhanaulti",
  },
  {
    id: 22,
    name: "Mount Abu",
  },
  {
    id: 3,
    name: "Lonavala",
  },
];

const InputBox = ({ inputbox, setInputBox, cities }) => {
  let countries = cities;
  // const [input, setInputBox] = useState("");
  const [suggestion, setSuggestions] = useState([]);
  const [select, setSelect] = useState("");
  const [clicked, setClicked] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;
    let matches = [];

    if (value.length >= 1) {
      const regex = new RegExp(`${value}`, "gi");
      matches = countries.filter((item) => regex.test(item.name));
    }
    setSuggestions(matches);
    setInputBox(value);
  };

  const selectValue = (item) => {
    setSelect(item);
    setSuggestions("");
    setInputBox(item);
  };

  const clearSearch = () => {
    setInputBox("");
    setSuggestions("");
    setSelect("");
  };

  return (
    <div className="font-hk">
      <input
        className="outline-none  w-[80vw] h-[7vh] mt-5 mx-5 md:mx-0 md:mt-0 md:w-auto md:h-auto text-center text-[18px] bg-white md:bg-transparent placeholder-zinc-600 lg:placeholder-black md:font-semibold lg:font-normal "
        type="text"
        placeholder="Type your Destination"
        value={inputbox}
        onChange={handleChange}
        style={{ textTransform: "capitalize" }}
        onClick={() => {
          setClicked(!clicked);
        }}
      />

      {suggestion?.length > 0 ? (
        <div className="flex flex-row mt-6">
          <div className="bg-white cursor-pointer rounded-lg opacity-90 w-full ">
            {suggestion.slice(0, 8).map((item) => {
              return (
                <div
                  className=" suggestions text-center px-2 my-2 py-2 text-[14px] border-b-[1px] font-semibold"
                  key={item.id}
                  onClick={() => {
                    selectValue(item.name);
                    setClicked(false);
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        clicked && (
          <div className="flex flex-row mt-6">
            <div className="bg-white cursor-pointer rounded-lg opacity-90 w-full ">
              {citySuggestions.map((item) => {
                return (
                  <div
                    className=" suggestions text-center px-2 my-2 py-2 text-[14px] border-b-[1px] font-semibold"
                    key={item.id}
                    onClick={() => {
                      selectValue(item.name);
                      setClicked(false);
                    }}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
          </div>
        )
      )}
      {/* {suggestion?.length > 0 ? (
        <div className="bg-white cursor-pointer rounded-lg">
          {suggestion.map((item) => {
            return (
              <div
                className="text-center p-1 text-[14px] border-b-[1px] font-semibold"
                key={item.id}
                onClick={() => selectValue(item.name)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
      ) : null} */}
    </div>
  );
};

export default InputBox;
